/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect, useMemo } from "react";
import { FaUsers, FaUserCheck } from "react-icons/fa";
import { useFetchData } from "../../../customHooks/useGetDashboardData";
import { IconWrapper } from "../../../customHooks/useIcon";
import { formatDateForDisplay } from "../../../utils/formatters";
import { IUser } from "../../../utils/interfaces";
import CardLayout from "../../Cards/CardLayout";
import StatsCard2 from "../../Cards/statsCard2";
import CardError from "../../feedBacks/CardError";
import Loader from "../../feedBacks/loader";
import NoContent from "../../feedBacks/NoContent";
import TableTemplate from "../../Table/Table";
import { ImUserMinus } from "react-icons/im";
import AppHeading from "../../texts/Headings";
import { HeadingType } from "../../../enums/componentEnums";
import WebsiteVisitChart from "../../Charts/PageVistiChart";
import { useNavigate } from "react-router-dom";
const columns = [
  "Name",
  "Company",
  "Email address",
  "Department",
  "Last login",
];
interface IUserAnalyticsStats {
  total_users: number;
  active_users: number;
  inactive_users: number;
  staff_users: number;
  non_staff_users: number;
  superusers: number;
  admin_users: number;
  operation_users: number;
}
const UserAnalytics = ({ company_id }: { company_id?: string }) => {
  const router = useNavigate();
  const [page, setPage] = React.useState(1);
  const [isNextPageLoading, setIsNextPageLoading] = React.useState(false);
  const ROWS_PER_PAGE = 10;
  const {
    data: userData,
    isLoading: isUserDataLoading,
    error: userDataError,
    refetch,
  }: any = useFetchData(
    ["/users", "fetchAllUsers", company_id, page], // include page in query key
    "/users",
    {
      page,
      page_size: ROWS_PER_PAGE,
      company_id,
    },
    //   @ts-ignore
    {
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      staleTime: 0,
    }
  );

  const MAP_API_TO_STATS = (data: IUserAnalyticsStats) => [
    {
      icon: <IconWrapper icon={FaUsers} />,
      title: "Total Users",
      value: data.total_users,
      // percentageChange: "+5%",
      backgroundColor: "gradient-yellow",
      extraClass: "gradient-yellow",
      // description: "than last month",
    },

    {
      icon: <IconWrapper icon={FaUserCheck} />,
      title: "Active Users",
      value: data.active_users,
      // percentageChange: "+25%",
      backgroundColor: "gradient-green",
      extraClass: "gradient-green",
      description: "than last month",
    },
    {
      icon: <IconWrapper icon={ImUserMinus} />,
      title: "Inactive Users",
      value: data.inactive_users,
      // percentageChange: "-10%",
      backgroundColor: "gradient-black",
      extraClass: "gradient-black",
      description: "than last month",
    },
    {
      icon: <IconWrapper icon={ImUserMinus} />,
      title: "Non Staff",
      value: data.non_staff_users,
      // percentageChange: "-10%",
      backgroundColor: "gradient-blue",
      extraClass: "gradient-blue",
      description: "than last month",
    },
  ];

  const {
    data: userAnalyticsData,
    isLoading: isUserAnalyticsLoading,
    error: userAnalyticsError,
  } = useFetchData<any, IUserAnalyticsStats>(
    ["/users", "fetchUserAnalytics", company_id],
    "/user-analytics/detailed",
    {},
    // @ts-ignore
    {}
  );
  const userDataLoading = isUserDataLoading || isNextPageLoading;
  const transformedData = useMemo(() => {
    return userAnalyticsData ? MAP_API_TO_STATS(userAnalyticsData) : [];
  }, [userAnalyticsData]);

  const tableData =
    userData?.results.map((item: IUser) => ({
      "User ID": item.id,
      Name: `${item.first_name} ${item.last_name}`,
      Company: item.company.name,
      // "Employee ID": item.employee_id,
      "Email address": item.email,
      Department: item.access_level,
      "Last login": formatDateForDisplay(item.last_login),
      ...item,
    })) ?? [];
  const handleRowClick = (rowData: any) => {
    console.log(rowData);
    router(
      `/dashboard/admin/user-analytics-detail/${rowData.id}/${company_id}`
    );
  };
  const handlePageChange = (newPage: number) => {
    setIsNextPageLoading(true);
    setPage(newPage);
  };
  useEffect(() => {
    refetch().finally(() => {
      setIsNextPageLoading(false);
    });
  }, [page, refetch]);
  return (
    <div
      className=" w-full p-10 !bg-[#f5f5f5] !h-full min-h-[50vh] flex flex-col gap-10 items-start !justify-start rounded-xl"
    >
      <div className="w-full flex  flex-col gap-10 mt-10">
        {isUserAnalyticsLoading ? (
          <div className="flex justify-center items-center h-full w-full">
            <Loader />
          </div>
        ) : userAnalyticsError ? (
          <CardError message="Error fetching user analytics" />
        ) : (
          <div className="grid gap-10 grid-cols-[repeat(auto-fill,minmax(220px,1fr))] w-full ">
            {transformedData.map((stat, index) => (
              <StatsCard2
                key={index}
                icon={stat.icon}
                title={stat.title}
                value={stat.value}
                // percentageChange={stat.percentageChange}
                backgroundColor={stat.backgroundColor}
                extraClass={stat.extraClass}
                // description={stat.description}
              />
            ))}
          </div>
        )}
      </div>
      <div className="w-full">
        <WebsiteVisitChart />
      </div>
      <CardLayout title="">
        <AppHeading
          text="User activity"
          type={HeadingType.SUB}
          className="mb-4 !self-start !justify-start"
        />
        {userDataLoading ? (
          <div className="w-full min-h-[10rem] flex flex-col justify-center items-center">
            <Loader />
          </div>
        ) : userDataError ? (
          <CardError message="Error fetching users" />
        ) : userData.length === 0 ? (
          <NoContent message="No user data found" />
        ) : (
          <div className="flex  flex-col items-center justify-center w-full">
            <TableTemplate
              data={tableData}
              columns={columns}
              extraAction={false}
              totalCount={userData?.total_results || 0}
              page={page}
              onPageChange={handlePageChange}
              rowsPerPage={ROWS_PER_PAGE}
              makeRowClickable={true}
              rowLink={handleRowClick}
            />
          </div>
        )}
      </CardLayout>

      {/* <AddEmployeeModal
        isModalOpen={editUserModal}
        closeModal={() => setEditUserModal(false)}
        enableOutsideClick={false}
        type="edit"
        data={userDetails as IUser}
      /> */}
    </div>
  );
};

export default UserAnalytics;
